<div class="pol-wrap">
  <div class="pol-toolbar">
    <span class="pol-env" [class.pol-env--prod]="environment === 'production'" *ngIf="environment">PowerOffice {{ environment | uppercase }}</span>
    <mat-slide-toggle [(ngModel)]="problemsOnly" (change)="filter()">Problems only</mat-slide-toggle>
    <span class="pol-spacer"></span>
    <button mat-stroked-button (click)="load()" [disabled]="loading"><mat-icon>refresh</mat-icon> Refresh</button>
  </div>

  <p class="pol-error" *ngIf="error">{{ error }}</p>

  <div class="pol-table-wrap">
    <table class="pol-table">
      <thead>
        <tr><th>When</th><th>Who</th><th>Action</th><th>Customer</th><th>Result</th><th></th></tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let a of shown">
          <tr class="pol-row" [class.pol-row--bad]="a.failed || a.refused" (click)="expanded[a.actionId] = !expanded[a.actionId]">
            <td class="pol-nowrap">{{ a.at | date:'dd.MM.yy HH:mm:ss' }}</td>
            <td>{{ a.who }}</td>
            <td>{{ a.label }}<span class="pol-muted" *ngIf="a.env !== environment"> · {{ a.env }}</span></td>
            <td>{{ a.card }}</td>
            <td>
              <span class="pol-badge pol-badge--bad" *ngIf="a.failed">Failed</span>
              <span class="pol-badge pol-badge--warn" *ngIf="!a.failed && a.refused">Refused</span>
              <span class="pol-badge pol-badge--muted" *ngIf="a.undone">Undone</span>
              <span class="pol-badge pol-badge--ok" *ngIf="!a.failed && !a.refused && !a.undone">OK</span>
              <span class="pol-muted"> {{ a.rows.length }} change{{ a.rows.length === 1 ? '' : 's' }}</span>
            </td>
            <td class="pol-actions">
              <button mat-stroked-button color="warn" *ngIf="a.canUndo" [disabled]="busy[a.actionId]" (click)="$event.stopPropagation(); undo(a)">
                <mat-icon>undo</mat-icon> Undo
              </button>
            </td>
          </tr>
          <tr *ngIf="expanded[a.actionId]" class="pol-detail">
            <td colspan="6">
              <div *ngFor="let r of a.rows" class="pol-entry" [class.pol-entry--bad]="r.ok === false">
                <div class="pol-entry-head">
                  <span class="pol-mono">{{ r.kind === 'firestore' ? 'card ' + r.doc : (r.method || r.kind) + ' ' + (r.path || '') }}</span>
                  <span *ngIf="r.status" class="pol-muted"> · {{ r.status }}</span>
                  <span *ngIf="r.durationMs" class="pol-muted"> · {{ r.durationMs }} ms</span>
                  <span *ngIf="r.undoneAt" class="pol-badge pol-badge--muted">undone {{ r.undoneAt | date:'dd.MM HH:mm' }} by {{ r.undoneBy || '—' }}</span>
                </div>
                <div class="pol-err" *ngIf="r.error">{{ r.error }}</div>
                <table class="pol-changes" *ngIf="r.changes.length">
                  <tr *ngFor="let c of r.changes"><td class="pol-mono">{{ c.field }}</td><td class="pol-before">{{ c.before ?? '—' }}</td><td>→</td><td>{{ c.after ?? '—' }}</td></tr>
                </table>
                <div class="pol-muted pol-small" *ngIf="r.resultId">Created id {{ r.resultId }}</div>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="!loading && !shown.length"><td colspan="6" class="pol-muted pol-empty">Nothing logged yet.</td></tr>
      </tbody>
    </table>
  </div>
</div>
